import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbb3cab0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pl-2 pt-2 w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Share your insights", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "pb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "italic" }, "Add your insights...", -1))
const _hoisted_6 = ["id", "errors"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "pb-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "italic" }, "Where can people learn more...", -1))
const _hoisted_10 = ["id", "errors"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "w-full" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_input = _resolveComponent("base-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("form", {
      "data-test-id": "create-post-form",
      class: "flex flex-col",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.callCreatePost && _ctx.callCreatePost(...args)), ["prevent"]))
    }, [
      _createVNode(_component_base_input, {
        modelValue: _ctx.title,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.title) = $event)),
        label: "Post Title",
        type: "text",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate()))
      }, null, 8, ["modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.$errors, (error, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "text-xs text-red-700"
        }, [
          (error.$property === 'title')
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(error.$message), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          contenteditable: "true",
          class: "editable",
          id: _ctx.contentTextId,
          errors: _ctx.v$.$errors.content_text,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.linkifyContentText()))
        }, null, 40, _hoisted_6)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.$errors, (error, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "text-xs text-red-700"
        }, [
          (error.$property === 'content_text')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(error.$message), 1))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", {
          contenteditable: "true",
          class: "editable",
          id: _ctx.learnMoreTextId,
          errors: _ctx.v$.$errors.learn_more,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.linkifyLearnMoreText()))
        }, null, 40, _hoisted_10),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.$errors, (error, key) => {
          return (_openBlock(), _createElementBlock("div", {
            key: key,
            class: "text-xs text-red-700"
          }, [
            (error.$property === 'learn_more')
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.$message), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("button", {
          disabled: _ctx.buttonDisabled,
          type: "submit",
          class: "btn btn-primary relative float-right mr-2",
          "data-test-id": "create-post-button",
          onClick: [
            _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.callCreatePost && _ctx.callCreatePost(...args))),
            _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.buttonDisabled && _ctx.buttonDisabled(...args)), ["prevent"]))
          ]
        }, " Post ", 8, _hoisted_13),
        _createElementVNode("button", {
          disabled: _ctx.buttonDisabled,
          type: "submit",
          class: "btn btn-cancel relative float-right mr-2",
          "data-test-id": "cancel-post-button",
          onClick: [
            _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.callCancelPost && _ctx.callCancelPost(...args))),
            _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.buttonDisabled && _ctx.buttonDisabled(...args)), ["prevent"]))
          ]
        }, " Cancel ", 8, _hoisted_14)
      ])
    ], 32)
  ]))
}